(function () {
    const header = () => {
        $("[data-hover-opacity]").hover(
            function () {
                const id = $(this).data("hover-opacity");
                $(`[data-hover-opacity=${id}]`).addClass("opacity");
                $(this).removeClass("opacity");
            },
            function () {
                const id = $(this).data("hover-opacity");
                $(`[data-hover-opacity=${id}]`).removeClass("opacity");
            }
        );

    };

    $('.header-mega-menu__main-link.has-hover').on({
        mouseenter: function (ev) {
            ev.preventDefault();

            let parent = $(this).closest('.header-mega-menu');
            parent.find('.header-mega-menu__main-link').not(this).closest('.header-mega-menu__main-link-wrapper').removeClass('show');
            $(this).closest('.header-mega-menu__main-link-wrapper').addClass('show');
        },
        mouseleave: function (ev) {
            ev.preventDefault();
        }
    });

    let touchCount = 0,
        evTarget;

    $('.menu-list__item').on({
        mouseenter: function(ev) {
            ev.preventDefault();

            let menuItem = $(this).closest('.header-mega-menu__main-link-wrapper');
            let bannerImage = $(this).data('image');
            let bannerTitle = $(this).data('title');
            let bannerText = $(this).data('text');

            let lastBannerImage1 = menuItem.find('.menu-banner-image-1 img').attr("src");

            menuItem.find('.menu-banner-image-1 img').attr('src', `${bannerImage}`);
            menuItem.find('.menu-banner-image-1 img').attr('srcset', `${bannerImage}`);
            if (bannerImage == '') {
                menuItem.find('.menu-banner-image-1 img').attr("hidden",true);
            } else {
                menuItem.find('.menu-banner-image-1 img').attr("hidden",false);
            }

            menuItem.find('.menu-banner-content__title').text(bannerTitle);
            menuItem.find('.menu-banner-content__text').text(bannerText);

            /*if (lastBannerImage1.indexOf(bannerImage) <= 0) {
                $('.header-mega-menu__banner').hide().fadeIn(450);
            }*/
        },
        mouseleave: function(ev) {
            ev.preventDefault();
        },
        touchstart: function (ev) {
            ev.preventDefault();
            touchCount = evTarget === ev.currentTarget ? touchCount+1 : 1;

            if (touchCount === 1) {
                let menuItem = $(this).closest('.header-mega-menu__main-link-wrapper');
                let bannerImage = $(this).data('image');
                let bannerTitle = $(this).data('title');
                let bannerText = $(this).data('text');

                menuItem.find('.menu-banner-image-1 img').attr('src', `${bannerImage}`);
                menuItem.find('.menu-banner-image-1 img').attr('srcset', `${bannerImage}`);
                if (bannerImage == '') {
                    menuItem.find('.menu-banner-image-1 img').attr("hidden", true);
                } else {
                    menuItem.find('.menu-banner-image-1 img').attr("hidden", false);
                }

                menuItem.find('.menu-banner-content__title').text(bannerTitle);
                menuItem.find('.menu-banner-content__text').text(bannerText);
            } else if (touchCount === 2) {
                window.location = ev.currentTarget.href;
            }
            evTarget = ev.currentTarget;

        }
    });

    document.addEventListener("shopify:section:load", header);
    header();
})();
